export const MMW_URL = {
  ios: "https://apps.apple.com/tt/app/%EB%A9%94%EC%9D%B4%ED%81%AC%EB%A7%88%EC%9D%B4%EC%9B%A8%EB%94%A9/id1595743450",
  android: "https://play.google.com/store/apps/details?id=com.makemywedding",
  cafe: "https://cafe.naver.com/makemywedding",
  blog: "https://blog.naver.com/makemywedding_editor",
  instagram: "https://www.instagram.com/makemywedding_official/",
  kakao: "https://pf.kakao.com/_PgmHb/chat",
  kakaoVenue: "http://pf.kakao.com/_rwqHxj/chat",
  WEDDING_FEED_LINK:
    "http://makemywedding-web.s3-website.ap-northeast-2.amazonaws.com",
};

export const CONSTANTS = {
  MAX_WIDTH: 540,
  B2B_COMPANY_LIST: [
    "이마트",
    "좋은사람들",
    "테트라팩",
    "한화",
    "LG 에너지솔루션",
    "SK 그룹",
  ],
};
